import {
	MDBBtn,
	MDBCollapse,
	MDBContainer,
	MDBIcon,
	MDBNavbar,
	MDBNavbarBrand,
	MDBNavbarItem,
	MDBNavbarNav,
	MDBNavbarToggler,
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { logout } from "../../Pages/Login/action";
import logo from "../../Assets/logoWhite.png";
import logoFootWhite from "../../Assets/logoFootWhite.png";

import styles from "./style.module.scss";
import { showPopup } from "../../Containers/App/action";

function Header({ isAuthenticated, children, refreshToken }) {
	const [show, setShow] = useState(false);

	const path = window.location.pathname;
	useEffect(() => {
		if (path === "/timeline") {
			return setActiveMenu("timeline");
		}
		if (path === "/explore") {
			return setActiveMenu("explore");
		}
		if (refreshToken) {
			return setActiveMenu("home");
		}
	}, [path]);

	const [activeMenu, setActiveMenu] = useState(0);

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const onClickLogout = () => {
		const logutCallback = () => {
			toast.success("Successfully signed out!");
			navigate("/login");
		};
		dispatch(logout(logutCallback, "call", refreshToken));
	};
	const onClickOpen = () => {
		dispatch(showPopup({ isOpen: true, content: "add-post" }));
	};

	const getActiveTab = (index, mode) => {
		if (index === activeMenu && !mode) return styles.active;
		if (index === activeMenu && mode) return styles.activeMobile;
		return "";
	};
	const menus = [
		{
			link: "/",
			tab: "home",
			text: "My Journey",
		},
		{
			link: "/timeline",
			tab: "timeline",
			text: "Timeline",
		},
		{
			link: "/explore",
			tab: "explore",
			text: "Explore",
		},
	];
	return (
		<>
			<MDBNavbar expand='xl' className={`${styles.navbar} sticky-top`}>
				<MDBContainer className={styles.navbarContainer}>
					<MDBNavbarBrand
						href={`/`}
						style={{ color: "white", fontWeight: "600", fontSize: "22px" }}
					>
						<div className='mb-1 rounded-circle mt-2'>
							<img src={logo} alt='logo' className={styles.logo} />
						</div>
					</MDBNavbarBrand>
					<MDBNavbarToggler
						type='button'
						aria-expanded='false'
						arial-label='Toogle navigation'
						style={{ color: "white" }}
						onClick={() => setShow(!show)}
					>
						<MDBIcon icon='bars' fas />
					</MDBNavbarToggler>
					<MDBCollapse show={show} navbar>
						<MDBNavbarNav right fullWidth={false} className='mb-2 mb-lg-0'>
							{refreshToken
								? menus.map((menu, index) => {
										return (
											<MDBNavbarItem key={index}>
												<Link to={menu.link}>
													<div className={styles.linkHolder}>
														<p
															className={`header-text ${styles.navItem}${getActiveTab(
																menu.tab,
																"mobile"
															)}`}
														>
															{menu.text}
														</p>
														<div className={getActiveTab(menu.tab)} />
													</div>
												</Link>
											</MDBNavbarItem>
										);
								  })
								: ""}
							<MDBNavbarItem>
								{isAuthenticated ? (
									<div onClick={onClickLogout} className={styles.linkHolder}>
										<p className={`header-text ${styles.navItem}`}>Sign out</p>
									</div>
								) : (
									<Link to='/login'>
										<div className={styles.linkHolder}>
											<p className={`header-text ${styles.navItem}`}>Sign in</p>
										</div>
									</Link>
								)}
							</MDBNavbarItem>
						</MDBNavbarNav>
					</MDBCollapse>
				</MDBContainer>
			</MDBNavbar>
			{isAuthenticated ? (
				<MDBBtn onClick={onClickOpen} floating className={styles.addPost}>
					<img src={logoFootWhite} alt='logo' style={{ width: 22 }} />
				</MDBBtn>
			) : (
				""
			)}
			<div className={styles.childrenContainer}>
				{children}
			</div>
		</>
	);
}

export default Header;
